import type { FC, ReactNode } from "react";
import { Banner } from "../../primitives/Banner";
import { Spinner } from "../../primitives/Spinner";

export type InProgressBannerProps = {
	/** In-progress message shown next to the spinner. */
	children: ReactNode;
	className?: string;
	testId?: string;
	trackingId?: string;
};

/**
 * Info banner with a leading spinner for in-progress async work.
 * Composes the `Banner` and `Spinner` primitives into a reusable in-progress state.
 */
export const InProgressBanner: FC<InProgressBannerProps> = ({
	children,
	className,
	testId = "in-progress-banner",
	trackingId,
}) => (
	<Banner tone="info" className={className} data-testid={testId} trackingId={trackingId}>
		<Banner.Leading>
			<Spinner size="md" className="text-secondary" />
		</Banner.Leading>
		<Banner.Content>{children}</Banner.Content>
	</Banner>
);
